import React from 'react'
import PropTypes from 'prop-types'

import * as S from './styled'
import { AVAILABLE_BRANDS } from 'styles/theme'
import { useTheme } from 'styled-components'

const Layout1 = props => {
  const { color } = useTheme()
  if (color === AVAILABLE_BRANDS.CLOUD_LIGHT) {
    return (
      <div>
        <S.StyledLayoutLight {...props} />
      </div>
    )
  }
  if (color === AVAILABLE_BRANDS.CLOUD_DARK) {
    return <S.StyledLayoutDark {...props} />
  }
}

Layout1.defaultProps = {
  content: {},
}

Layout1.propTypes = {
  content: PropTypes.object,
}

export default Layout1
